module.exports = __webpack_public_path__ + "static/img/4.ba0fc0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/zh/4.png
// module id = yRSB
// module chunks = 0